import './custom-footer.css';
import { navigator } from '../../../Controllers/Navigator';
import { Link } from 'react-router-dom';

const FooterSection = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-bottom-left">
              <p>&copy; {currentYear} Wyens LLC. All rights reserved.</p>
            </div>
            <div className="footer-bottom-center">
              <Link onClick={navigator().afterLocateFunctions} to="/privacy">Privacy Policy</Link>
              <Link onClick={navigator().afterLocateFunctions}  to="/terms">Terms & Conditions</Link>
              <Link onClick={navigator().afterLocateFunctions}  to="/refundpolicy">Refund Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;